const publicNavLinksData = [
  { title: "Product", href: "/product", description: "View the product page" },
  {
    title: "Technology",
    href: "/technology",
    description: "View the technology approach",
  },
  { title: "FAQ", href: "/faq", description: "View frequently asked questions" },
  { title: "Contact", href: "/contact", description: "Contact MoveOn" },
];

export type PublicNavLinks = typeof publicNavLinks;

const publicNavLinks = Object.freeze(publicNavLinksData);
export default publicNavLinks;
